export default "__VITE_ASSET__CmpjdH8C__"